module.exports = __webpack_public_path__ + "img/star_4.2fb4b021.jpg";